import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { MimberOrganizationConfigDto, ResponseDto } from "@mimber/schema"
import { configKeys } from "../config.utils"

/**
 * Organization-specific hook for fetching application configuration
 * Can only be used in mimber-organization web app
 */
export const useConfig = (
  options?: UseQueryOptions<ResponseDto<MimberOrganizationConfigDto>, Error>
): UseQueryResult<ResponseDto<MimberOrganizationConfigDto>, Error> => {
  guardAppUsage("mimber-organization", "useConfig")

  const { unauthenticatedServer } = useServerContext()

  return useQuery({
    queryKey: configKeys.getConfig(),
    queryFn: async () => {
      const response =
        await unauthenticatedServer.get<
          ResponseDto<MimberOrganizationConfigDto>
        >("config")
      return response.data
    },
    staleTime: 5 * 60 * 1000, // Consider config data fresh for 5 minutes
    refetchOnWindowFocus: true, // Refetch when user returns to app
    ...options,
  })
}
